export const state = {
  params: null,
}

export const getters = {
  params: (state) => {
    return _.get(state, "params")
  },
}

export const actions = {
  reset: ({ commit, dispatch }) => {
    dispatch("app/setActiveDrawer", null, { root: true })
    commit("RESET_STATE")
  },
  setParams: ({ commit, dispatch }, params) => {
    if (params) {
      dispatch("app/setActiveDialog", { dialog: "activeModal" }, { root: true })
    }
    commit("SET_PARAMS", params)
    dispatch("app/setActiveDrawer", "CommentsDrawerWrapper", {
      root: true,
    })
  },
}

export const mutations = {
  SET_PARAMS(state, params) {
    state.params = params
  },
  RESET_STATE(state) {
    state.params = null
  },
}
